import { createFileRoute, redirect } from "@tanstack/react-router";

import { AgentsPage } from "../components/agents/AgentsPage";
import { HomePageRoute } from "../components/home/HomePageRoute";

/**
 * `/$org/agents` — the agents that work for the organization, a page inside
 * Home: the rail keeps Home selected and Home's sidebar stays beside it
 * (components/home/homePaths).
 */
function AgentsRouteView() {
  return (
    <HomePageRoute>
      <AgentsPage />
    </HomePageRoute>
  );
}

export const Route = createFileRoute("/$org/agents")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: AgentsRouteView,
});
